//import i18n from 'i18next';
import { useTranslation } from "../helpers/i18n";

export default function UseLang() {
  const { i18n } = useTranslation();
  const change = (language) => {
    let lng = i18n.language;
    let url = window.location.href;

    if (url.indexOf("/".concat(lng)) > -1 && language !== lng) {
      url = url.replace("/".concat(lng), "/".concat(language));
    } else {
      //url=url.concat(language)
      url = window.location.origin.concat(
        "/",
        language,
        window.location.pathname
      );
    }
    window.history.pushState({}, null, url);

    //wait for keep-alive with new lang (called by changelanguagehead), then update local i18n languages in header and body
    if (window?.changeLanguageHead) {
      window.changeLanguageHead(language).finally(() => {
        if (window?.changeLanguageBody) {
          window.changeLanguageBody(language);
        }
      });
    } else if (window?.changeLanguageBody) window.changeLanguageBody(language);

    try {
      window.current_lang = language;
      if (window.LiveCaller)
        window.LiveCaller.$emit("app.locale.update", language);
    } catch (ex) {
      console.log(ex);
    }
  };
  const setLang = () => {
    const url = window.location.pathname.split("/");
    switch (url[1]) {
      case "ru":
        window.current_lang = "ru";
        return i18n.changeLanguage("ru");
      case "en":
        window.current_lang = "en";

        return i18n.changeLanguage("en");
      default:
        window.current_lang = "ka";

        return i18n.changeLanguage("ka");
    }

    /*if (url.indexOf("ru") > -1) {
      window.current_lang = "ru";
      return i18n.changeLanguage("ru");
    }
    if (url.indexOf("en") > -1) {
      window.current_lang = "en";

      return i18n.changeLanguage("en");
    }
    window.current_lang = "ka";

    return i18n.changeLanguage("ka");*/
  };
  return { change, setLang };
}
